import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CalendarComponent } from '../calendar/calendar.component';

@Component({
  selector: 'app-scheduler-popover',
  templateUrl: './scheduler-popover.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, CalendarComponent],
})
export class SchedulerPopoverComponent {
  @Input() view: 'Day' | 'Week' | 'Month' = 'Week';
  @Input() readonly = false;
  @Input() blockEvents = true;
  @Input() showWaitingTasks = false;
  @Input() allowLegend = false;
  @Input() showHeaderBar = true;
  @Input() selectedDate!: string;
  @Input() technicians!: number[];
  @Output() clickEvent = new EventEmitter();
}
